import React, { useEffect, useRef, useState, useMemo, lazy } from "react";

import { Grid, Tooltip, Typography } from "@mui/material";

import axios from "axios";

import Layout from "../../../layout/Layout";

import { config, departmentMasterAPI } from "../../../config";
import { AddDepartments } from "../../../components/AddDepartment";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "react-data-table-component";
import EditLocationOutlinedIcon from "@mui/icons-material/EditLocationOutlined";
import IconButton from "@mui/material/IconButton";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { AlertMessage } from "../../../components/AlertMessage";
import { MaterialReactTable } from "material-react-table";

let field = "id",
  orderBy = "desc";

function AddRoleMaster() {
  const navigate = useNavigate();
  let intOffset = 0;
  const limit = 10;
  const [totalCount, setTotalCount] = useState(0);
  const [departmentMasterList, setdepartmentMasterList] = useState([]);

  const handleReportPagination = (e) => {
    intOffset =
      e.target.innerText === "1"
        ? 0
        : (parseInt(e.target.innerText) - 1) * limit;
  };

  let assetsRef = useRef(false);
  const childRef = useRef();

  const handleEditdepartments = (DepartmentID, DepartmentName, status) => {
    childRef.current.setData(
      JSON.stringify({
        departmentID: DepartmentID,
        txtDepartmentName: DepartmentName,
        status: status,
        intType: 3,
      })
    );
  };

  const fetchData = (action) => {
    if (action === 1) {
      intOffset = 0;
    }
  };

  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10); //change to 10 after you remove paginationRowsPerPageOptions
  const [currentPage, setCurrentPage] = useState(1);

  let tempRefs = useRef(false);
  useEffect(() => {
    if (tempRefs.current === false) {
      fetchUsers(1);
    }
  }, []);

  const fetchUsers = async (page, rowsPerPage) => {
    if (tempRefs.current === false) {
      const data = JSON.stringify({
        intLimit: rowsPerPage ? rowsPerPage : 10,
        intOffset: rowsPerPage ? (page - 1) * rowsPerPage : 0,
        intType: 2,
      });

      config.method = "POST";
      config.data = data;
      config.url = departmentMasterAPI;

      axios(config)
        .then(function (response) {
          setdepartmentMasterList(response.data["result"]);
          setTotalCount(response.data.totalCount);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    tempRefs.current = true;
  };

  const handleDeletedepartments = async (id) => {
    const confirm = window.confirm("Are you sure want to delete this?");
    if (!confirm) return;

    const data = JSON.stringify({
      intDepartmentID: id,
      intType: 4,
    });

    config.method = "POST";
    config.data = data;
    config.url = departmentMasterAPI;

    axios(config)
      .then(function (response) {
        window.location.reload(false);
        alert("Department Deleted");

        // fetchUsers(1);
      })
      .catch(function (error) {
        console.log(error);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: error.data.message,
            messageType: "error",
          })
        );
      });
  };

  const handlePageChange = (page) => {
    tempRefs.current = false;
    fetchUsers(page, rowsPerPage);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    if (!departmentMasterList.length) return; //when the table is rendered for the first time, this would trigger, and we don't need to call fetchUsers again
    tempRefs.current = false;
    fetchUsers(1, newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const handleSort = (column, sortDirection) => {
    setLoading(true);
    setTimeout(() => {
      field = column.field;
      orderBy = sortDirection;
      fetchUsers(1);
      setLoading(false);
    }, 100);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "department_name",
        header: "Department Name",
        size: 200, // width in pixels
        enableSorting: true,
      },
      {
        accessorFn: (row) => (row.status === 2 ? "Active" : "Inactive"),
        header: "Status",
        size: 150,
        Cell: ({ cell }) => (
          <Typography
            className={`${
              cell.getValue() === "Active" ? "active-status" : "inactive-status"
            }`}
          >
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        header: "Action",
        size: 100,
        Cell: ({ row }) => (
          <Tooltip title="Edit department" arrow>
            <IconButton
              color="success"
              onClick={() =>
                handleEditdepartments(
                  row.original.id,
                  row.original.department_name,
                  row.original.status
                )
              }
              aria-label="edit department"
            >
              <EditLocationOutlinedIcon />
            </IconButton>
          </Tooltip>
        ),
        enableSorting: false,
      },
    ],
    []
  );

  return (
    <Layout>
      <AlertMessage ref={childRef} />
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Add Department
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Department</Typography>
              <Typography color="text.primary">Add</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="success"
              className="button_first"
              href="/config/positions-master"
              startIcon={<AddIcon />}
            >
              Add Position
            </LoadingButton>
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>
        <Grid className="form_design">
          <AddDepartments ref={childRef} fetchData={fetchData} />
          <div className="empty-space-20"></div>
          <Grid className="small_table">
            <MaterialReactTable
              columns={columns}
              enableGlobalFilter={false}
              enableFullScreenToggle={false}
              enableDensityToggle={false}
              data={departmentMasterList}
              state={{
                isLoading: loading,
                pagination: {
                  pageIndex: currentPage - 1, // MRT uses zero-based index
                  pageSize: rowsPerPage,
                },
              }}
              manualPagination
              rowCount={totalCount}
              onPaginationChange={(updater) => {
                const newPagination =
                  typeof updater === "function"
                    ? updater({
                        pageIndex: currentPage - 1,
                        pageSize: rowsPerPage,
                      })
                    : updater;
                handlePageChange(newPagination.pageIndex + 1); // convert back to one-based
                handleRowsPerPageChange(newPagination.pageSize);
              }}
              enableStickyHeader
              muiTableContainerProps={{
                sx: { maxHeight: "550px" },
              }}
              muiTableHeadCellProps={{
                sx: {
                  "& input": {
                    color: "#fff !important",
                    "&::placeholder": {
                      color: "#fff !important",
                      opacity: 1,
                    },
                  },
                  "& .MuiSelect-select": {
                    color: "#fff !important", // selected text color
                  },
                  "& .MuiSelect-icon": {
                    color: "#fff !important", // dropdown arrow color
                  },
                  color: "#fff",
                  fontWeight: "bold",
                  "& svg": {
                    color: "#fff",
                  },
                  "& .MuiTableSortLabel-root": {
                    color: "#495057",
                    "&.Mui-active": {
                      color: "#fff",
                      "& .MuiTableSortLabel-icon": {
                        color: "#fff !important",
                      },
                    },
                  },
                  "& .MuiTableSortLabel-icon": {
                    color: "#fff !important",
                  },
                },
              }}
              muiTablePaperProps={{
                sx: {
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                },
              }}
              initialState={{
                density: "compact",
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default AddRoleMaster;
